import React, { useEffect, useState } from "react";
import {
  Col,
  Form,
  Input,
  Modal,
  theme,
  Row,
  Divider,
} from "antd";
import { POST, PATCH } from "../../../frameworks/HttpClient";
import { URL_SETTING } from "../../../constants/urls";
import ErrorMessages from "../../../common/ErrorMessages";

export default function ShippingModalDetail(props) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { open, onClose, target, onUpdate } = props;
  const [errorMessage, setErrorMessage] = useState(null);

  const { TextArea } = Input;

  useEffect(() => {
    if (target) {
      form.setFieldsValue({
        ...target,
        buyer: target.buyer || props.buyerId,
      });
    } else {
      form.resetFields();
      form.setFieldsValue({
        buyer: props.buyerId,
      });
    }
  }, [open]);
  

  const {
    token: { colorWarning, colorSuccess },
  } = theme.useToken();

  const handleOK = async () => {
    setLoading(true);
    setErrorMessage(null);
    try {
      const data = await form.validateFields();
      if (!data.buyer) {
        throw new Error("Buyer is required");
      }
      if (target?.id) {
        await PATCH(`${URL_SETTING.SHIPPING_ADDRESS}${target.id}/`, data);
      } else {
        await POST(URL_SETTING.SHIPPING_ADDRESS, data);
      }
      onUpdate();
    } catch (error) {
      setErrorMessage(error.message || error.errorMessage);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    setErrorMessage(null)
  },[open])

  return (
    <Modal
      open={open}
      onCancel={onClose}
      okText={target ? "แก้ไข" : "เพิ่ม"}
      cancelText="ยกเลิก"
      title={target ? "แก้ไขที่อยู่ส่งสินค้า" : "เพิ่มที่อยู่ส่งสินค้า"}
      width={550}
      onOk={handleOK}
      destroyOnClose
      centered
      okButtonProps={{
        style: { backgroundColor: target ? colorWarning : colorSuccess },
        loading,
      }}
    >
      <ErrorMessages message={errorMessage} />

      <Form form={form} layout="vertical">
        <Row
          gutter={16}
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Col span={24}>
            <Form.Item
              label="ที่อยู่"
              name="address"
              rules={[{ required: true, message : 'กรุณากรอกข้อมูล' }]}
            >
              <TextArea autoSize={{ minRows: 2, maxRows: 4 }} placeholder="ที่อยู่"/>
            </Form.Item>
          </Col>
          <Divider>ข้อมูลผู้ติดต่อ</Divider>
          <Col span={16}>
            <Form.Item
              label="ชื่อผู้ติดต่อ"
              name="contact"
              rules={[{ required: false }]}
            >
              <Input placeholder="ชื่อผู้ติดต่อ"/>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="เบอร์โทรศัพท์"
              name="phone"
              rules={[{ required: false, message: "กรุณากรอกเบอร์โทรศัพท์" }]}
            >
              <Input placeholder="เบอร์โทรศัพท์"/>
            </Form.Item>
          </Col>
          <Form.Item name="buyer" style={{ display: "none" }}>
            <Input type="hidden" />
          </Form.Item>
        </Row>
      </Form>
    </Modal>
  );
}
